import { render, staticRenderFns } from "./field-modal.vue?vue&type=template&id=3f59fede&scoped=true"
import script from "./field-modal.vue?vue&type=script&lang=js"
export * from "./field-modal.vue?vue&type=script&lang=js"
import style0 from "./field-modal.vue?vue&type=style&index=0&id=3f59fede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f59fede",
  null
  
)

export default component.exports